module.exports = __webpack_public_path__ + "img/14.5c56a97b.png";